__turbopack_context__.v({
  "adviceImage": "ResponsiblePlay-module__VRAe0q__adviceImage",
  "adviceImageWrapper": "ResponsiblePlay-module__VRAe0q__adviceImageWrapper",
  "adviceItem": "ResponsiblePlay-module__VRAe0q__adviceItem",
  "adviceItems": "ResponsiblePlay-module__VRAe0q__adviceItems",
  "adviceText": "ResponsiblePlay-module__VRAe0q__adviceText",
  "adviceTextLink": "ResponsiblePlay-module__VRAe0q__adviceTextLink",
  "adviceTextNumber": "ResponsiblePlay-module__VRAe0q__adviceTextNumber",
  "adviceTextTitle": "ResponsiblePlay-module__VRAe0q__adviceTextTitle",
  "blockText": "ResponsiblePlay-module__VRAe0q__blockText",
  "bulletBoxWrapper": "ResponsiblePlay-module__VRAe0q__bulletBoxWrapper",
  "carousel": "ResponsiblePlay-module__VRAe0q__carousel",
  "carouselContainer": "ResponsiblePlay-module__VRAe0q__carouselContainer",
  "fixedHeaderHeightFudge": "ResponsiblePlay-module__VRAe0q__fixedHeaderHeightFudge",
  "getInTouchWrapper": "ResponsiblePlay-module__VRAe0q__getInTouchWrapper",
  "gotYourBack": "ResponsiblePlay-module__VRAe0q__gotYourBack",
  "gotYourBackHeader": "ResponsiblePlay-module__VRAe0q__gotYourBackHeader",
  "gotYourBackIcon": "ResponsiblePlay-module__VRAe0q__gotYourBackIcon",
  "gotYourBackInfo": "ResponsiblePlay-module__VRAe0q__gotYourBackInfo",
});
